/** The change types Portfolio offers on an approved programme. */

export type ChangeKind = "administrative" | "minor" | "major" | "revalidation";

export const ACTIVE_CHANGE_CASE_STATUSES = [
  "team-confirmation",
  "open",
  "submitted",
  "awaiting-approval",
  "changes-required",
] as const;

export const CHANGE_KINDS: readonly {
  kind: ChangeKind;
  label: string;
  icon: string;
  description: string;
  testId: string;
}[] = [
  {
    kind: "administrative",
    label: "Administrative amendment",
    icon: "pencil-simple",
    description:
      "Use for a limited administrative correction that does not change curriculum content, outcomes, assessment, credits, or award identity. Its approval route follows your institution's configured policy.",
    testId: "portfolio-start-administrative-amendment",
  },
  {
    kind: "minor",
    label: "Minor change",
    icon: "git-diff",
    description:
      "Use for a targeted curriculum update that retains the programme's overall purpose and identity. Once approved, it creates the next amendment revision, for example 1.1.",
    testId: "portfolio-start-minor-change",
  },
  {
    kind: "major",
    label: "Major change",
    icon: "git-diff",
    description:
      "Use for a substantial targeted change that needs formal scrutiny but is not a full scheduled revalidation. Once approved, it creates the next amendment revision, for example 1.1.",
    testId: "portfolio-start-major-change",
  },
  {
    kind: "revalidation",
    label: "Revalidation",
    icon: "arrows-clockwise",
    description:
      "Use for a comprehensive scheduled review of the whole programme. Revalidation follows full internal review and creates the next major curriculum revision, for example 2.0.",
    testId: "portfolio-start-revalidation",
  },
];
